import { getLinkTargetAttr } from '../helpers';

export default function customSignup() {
  const widgetName = 'customSignup';
  const widgetOpts = customSignupOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      const emailSignup = $('.tier-three .emailSignup');
      $widget.replaceWith(emailSignup);

      if (hasData) {
        createCustomSignUp(data.items);
        emailSignup.addClass('emailSignup-loaded');
      } else {
        $widget.remove();
        emailSignup.remove();
      }
    },
  });

  function createCustomSignUp(widgetData) {
    updateSignupFeature(widgetData, widgetName);
  }
}

function updateSignupFeature(data, idName) {
  const { Title, Description, URL } = data[0];
  const containerSectionClass = 'signup-container';

  const signupTitle = Description;
  const inputPlaceholder = 'Email Address';
  const buttonLabel = Title;

  const $signupElement = $(`.${containerSectionClass} .emailSignup`);
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
    </div>
    `);

  $signupElement.attr('id', idName);
  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);

  if (URL) {
    const newTab = getLinkTargetAttr(URL);
    $signupElement.find('.input-container').addClass('custom-signup').empty().append(`
      <a href="${URL}" class="button" ${newTab}>${buttonLabel}</a>`);
  }
}
